// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireConditionIsNotEmptyFragmentDoc = gql`
    fragment questionnaireConditionIsNotEmpty on QuestionnaireConditionIsNotEmpty {
  __typename
  question {
    id
  }
}
    `;